import differenceInDays from 'date-fns/differenceInDays';
import isSameYear from 'date-fns/isSameYear';
import PropTypes from 'prop-types';
import { useMemo } from 'react';
import Link from 'redux-first-router-link';
import styled from 'styled-components';

import Time, { RelativeTime } from '~/components/Time';
import { colors } from '~/utils/css-mixins';
import media from '~/utils/media';
import { authorPropType } from '~/utils/prop-types';

const Root = styled.div`
  font-size: 14px;
  line-height: 1.5714;

  ${props =>
    props.variant === 'headerMobile'
      ? `
    display: flex;
    flex-direction: column;
    order: -1;
    padding-bottom: 8px;
    flex: 1 0 45%;
  `
      : `
    display: none;
  `}

  ${media.tablet`
    display: ${props => (props.variant === 'headerMobile' ? 'none' : 'block')};
    margin-bottom: 2rem;

  ${props =>
    props.variant === 'headerDesktop' &&
    `flex: 1;
    display: flex;
    align-items: flex-end;
    justify-content: flex-end
  `}

  `}
`;

const Name = styled.a`
  font-weight: 600;
  text-decoration: ${props => props.as === 'a' && 'underline'};
  margin-right: 6px;
`;

const PubDate = styled(Time)`
  color: ${colors.textmeta};
`;

const Byline = ({ author, pubDate, variant }) => {
  // Show relative time on articles published today or yesterday,
  // show time on articles published in current year,
  // show year instead of time on older articles
  const timeProps = useMemo(() => {
    const now = new Date();
    const date = new Date(pubDate);
    const timeProps = {
      date,
    };
    if (differenceInDays(now, date) <= 1) {
      timeProps.as = RelativeTime;
    } else {
      timeProps.format = isSameYear(date, now)
        ? "d MMMM 'kl.' HH:mm"
        : 'd MMMM, yyyy';
    }
    return timeProps;
  }, [pubDate]);

  return (
    <Root variant={variant}>
      {author != null && (
        <Name as={Link} to={{ type: 'AUTHOR', payload: { slug: author.slug } }}>
          {author.firstname} {author.lastname}
        </Name>
      )}
      <PubDate {...timeProps} />
    </Root>
  );
};

Byline.propTypes = {
  author: authorPropType,
  pubDate: PropTypes.string.isRequired,
  variant: PropTypes.oneOf(['headerMobile', 'headerDesktop', 'footer'])
    .isRequired,
};

export default Byline;
